export const space3xs = ".25rem"; // 4px
export const space2xs = ".5rem"; // 8px
export const spaceXs = ".75rem"; // 12px
export const spaceSm = "1rem"; // 16px
export const spaceMd = "1.25rem"; // 20px
export const spaceLg = "1.5rem"; // 24px
export const spaceXl = "2rem"; // 32px
export const space2xl = "2.5rem"; // 40px
export const space3xl = "3rem"; // 48px
export const space4xl = "4rem"; // 64px
export const space5xl = "5rem"; // 80px
export const space6xl = "6rem"; // 96px
export const space7xl = "8rem"; // 128px
export const spaceBase = ".5rem"; // base unit of spacing .5rem
export const borderRadiusBase = "2px"; // $br-base • 2px
export const borderRadiusXs = "2px"; // 2px
export const borderRadiusSm = "4px"; // 4px
export const borderRadiusMd = "8px"; // 8px
export const borderRadiusLg = "12px"; // 12px
export const borderRadiusXl = "16px"; // 16px
export const boxShadowFocused = "0px 0px 3px 1px #fc5200"; // focused state box shadow
export const boxShadowError = "0px 0px 1px 1px #c50505"; // error field box shadow